import { MDSIconKind } from "@/mds/components/icon";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { MDSComboboxMention } from "../combobox.types";
import { getMentionId, getMentionLabel, getSortedMentions } from "../mention-utils";
import { StyledChipsContainer } from "./mention-chips.style";
import { useEffect } from "react";
import { MDSChip, MDSChipVariant } from "@/mds/components/chips/chip";

interface MentionChipsProps {
  mentions: MDSComboboxMention[];
  onRemove: (mentionId: string) => void;
  onInputChange?: () => void;
  className?: string;
  isDisabled?: boolean;
}

export const MentionChips = ({
  isDisabled = false,
  mentions,
  onRemove,
  className,
  onInputChange,
}: MentionChipsProps) => {
  useEffect(() => {
    onInputChange?.();
  }, [mentions, onInputChange]);

  if (mentions.length === 0) return null;

  const sortedMentions = getSortedMentions(mentions);

  return (
    <StyledChipsContainer
      className={className}
      data-mds-name="mention-chips"
      data-test-id="mention-chips"
    >
      {sortedMentions.map(mention => (
        <MDSChip
          key={getMentionId(mention)}
          variant={MDSChipVariant.Small}
          isDisabled={isDisabled}
          icon={
            mention.kind === MemCommonMentionKind.Collection
              ? MDSIconKind.Collection
              : MDSIconKind.Document
          }
          onRemove={() => onRemove(getMentionId(mention))}
          data-test-id={`mention-chip-${getMentionId(mention)}`}
        >
          {getMentionLabel(mention)}
        </MDSChip>
      ))}
    </StyledChipsContainer>
  );
};
